import StaticAlertTypes from "./Alerttypes";
import { AlertSmallIcon } from "../components/LCIcons";
import { municipalityAlertTypeInterface } from "../App";

/**
 * Un type d'alerte tel que consommé par l'UI — même forme que les entrées
 * de Alerttypes.ts (key/name/icon), pour que les écrans qui l'utilisaient
 * n'aient presque rien à changer.
 */
export interface ResolvedAlertType {
    key: string;
    name: string;
    icon: string;
}

/**
 * Résout la liste des types d'alertes d'une ville (currentMunicipality.alert_types,
 * plan multi-villes) vers une forme prête pour l'affichage.
 *
 * Les 32 types de base gardent leur icône SVG déjà intégrée au build React
 * (via libs/Alerttypes.ts, recherchée ici par `key` — aucun nouveau
 * téléversement nécessaire pour eux). Un type personnalisé utilise l'icône
 * téléversée depuis le Super Admin (icon_url) ; s'il n'en a pas encore, une
 * icône générique de repli.
 *
 * Nom de fichier volontairement distinct de "Alerttypes.ts" (pas
 * "alertTypes.ts") : macOS a un système de fichiers insensible à la casse
 * par défaut, les deux noms désignent le même fichier — collision déjà
 * vécue une fois pendant cette phase, à ne pas reproduire.
 */
export function resolveAlertTypes(
    types: municipalityAlertTypeInterface[] | undefined,
): ResolvedAlertType[] {
    if (!types) {
        return [];
    }
    return types.map((t) => {
        const local = StaticAlertTypes.find((s) => s.key === t.key);
        return {
            key: t.key,
            name: t.name,
            icon: local ? local.icon : t.icon_url || AlertSmallIcon,
        };
    });
}
